import { render, staticRenderFns } from "./addNoticeDialog.vue?vue&type=template&id=11ed4694"
import script from "./addNoticeDialog.vue?vue&type=script&lang=js"
export * from "./addNoticeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports